import React from 'react';
import { Link } from 'react-router-dom';
import { MenuListItem } from './styles';

export default ({ station }) => (
  <MenuListItem className="dropdown">
    <a
      className="dropdown-toggle"
      data-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      กราฟแสดงค่าการสั่นสะเทือน <span className="caret" />
    </a>
    <ul className="dropdown-menu">
      <li className="dropdown-header">สรุปเหตุการณ์</li>
      <li>
        <Link to="/seismic/event">ประมวลเหตุการณ์แรงสั่นสะเทือนที่ผ่านมา</Link>
      </li>
      <li className="dropdown-header">กราฟแสดงค่าการสั่นสะเทือน</li>
      {Object.keys(station).map((stationId, index) => (
        <li key={index}>
          <Link to={`/seismic/station/${stationId}`}>{station[stationId]}</Link>
        </li>
      ))}
    </ul>
  </MenuListItem>
);



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuLink/MenuSeismic.js